import React from 'react';
import { Alert, Button, Row } from 'antd';
import './styles.css';

import {
  ActivationSociogramModal,
  BupSpinner,
  ButtonBackData,
  DividerContainer,
  ErrorMessage,
  ItemImage,
  PageLayout,
  RequestClosureModal,
} from '@BUP/components';
import Diagnostico from '@BUP/assets/Images/Data/data_diagnostico.png';
import Sociograma from '@BUP/assets/Images/Data/data_sociograma.png';
import Recursos from '@BUP/assets/Documents/Data/Recursos_BRAVE-UP_DATA.zip';
import { useHistory } from 'react-router';
import {
  useBraveUpSurveysApi,
  useGetSurveyShow,
  useGetSurveysSociogram,
  useAuth,
  useSendCreationSociogram,
} from '@BUP/hooks';
import { isSociogram } from '@BUP/services/BraveUp';
import { useTranslation } from 'react-i18next';

const DataActiveInstrumentsPage = () => {
  const history = useHistory();
  const { user } = useAuth();
  const { survey, isLoadingSurvey, errorSurvey } = useBraveUpSurveysApi();
  const { isLoadingSurveyShow } = useGetSurveyShow(survey);
  const { isLoadingSurveySociogram, sociogram } = useGetSurveysSociogram(user);
  const [t] = useTranslation();
  const isDoneSociogram = sociogram?.isDone || false;

  const organizationId = user?.organizations?.id;
  const organizationName = user?.organizations?.name;

  const {
    dataResponse,
    errorResponse,
    confirmCreationSociogram,
  } = useSendCreationSociogram();

  const handleClickSociogram = async () => {
    await confirmCreationSociogram({
      data: { organizationId, name: `Sociograma ${organizationName}` },
    });
  };

  return (
    <PageLayout>
      <ButtonBackData onClick={() => history.goBack()} />

      <DividerContainer
        title={t('pages.data.activeInstruments.dividerTitle')}
      />

      {isLoadingSurvey || isLoadingSurveyShow || isLoadingSurveySociogram ? (
        <BupSpinner size="large" />
      ) : errorSurvey ? (
        <ErrorMessage />
      ) : (
        <>
          <p className="activeInstruments-paragraph">
            {t('pages.data.activeInstruments.introText1')}
          </p>

          <Row className="activeInstruments-row" justify="space-around">
            <ItemImage
              key="item1"
              src={Diagnostico}
              text={t('pages.data.activeInstruments.item1Title')}
              button1={[
                <Button
                  className="activeInstruments-row_itemImage__button-activation"
                  type="primary"
                  onClick={() =>
                    history.push('/data/instruments/activation-steps')
                  }
                  block
                >
                  {t('pages.data.activeInstruments.item1Button1')}
                </Button>,
              ]}
              button2={[
                <Button
                  className="activeInstruments-row_itemImage__button-resources"
                  type="primary"
                  block
                >
                  <a href={Recursos}>
                    {t('pages.data.activeInstruments.item1Button2Text1')}
                    <br />
                    {t('pages.data.activeInstruments.item1Button2Text2')}
                  </a>
                </Button>,
              ]}
              button3={<RequestClosureModal block />}
            />
            {isSociogram(user) ? (
              <ItemImage
                key="item2"
                span={10}
                src={Sociograma}
                text={t('pages.data.activeInstruments.item2Title')}
                button1={
                  sociogram === null || (!sociogram && !dataResponse?.id) ? (
                    <ActivationSociogramModal
                      modalTitle={t(
                        'pages.data.sociogram.activeSociogramModal.modalTitle'
                      )}
                      modalButton1={t(
                        'pages.data.sociogram.activeSociogramModal.modalButton1'
                      )}
                      modalButton2={t(
                        'pages.data.sociogram.activeSociogramModal.modalButton2'
                      )}
                      modalBody={t(
                        'pages.data.sociogram.activeSociogramModal.modalBody'
                      )}
                      buttonModalText={t(
                        'pages.data.activeInstruments.activationSociogramMessage'
                      )}
                      messageSuccess={t(
                        'pages.data.activeInstruments.messageSuccessSociogram'
                      )}
                      dataResponse={dataResponse?.id}
                      errorResponse={errorResponse}
                      errorMessageModal={t(
                        'pages.data.sociogram.activeSociogramModal.errorMessageModal'
                      )}
                      errorResponseMessage={errorResponse?.message}
                      handleClickSociogram={handleClickSociogram}
                    />
                  ) : (
                    <Alert
                      type="info"
                      message={
                        isDoneSociogram
                          ? t(
                              'pages.data.activeInstruments.completedSociogramMessage'
                            )
                          : t(
                              'pages.data.activeInstruments.activatedSociogramMessage'
                            )
                      }
                      showIcon
                    />
                  )
                }
              />
            ) : null}
          </Row>
        </>
      )}
    </PageLayout>
  );
};

export default DataActiveInstrumentsPage;
